import { useEffect } from 'react';

const LIFETIME_MS = 3600;

/** Transient reward notifications — XP, level-ups, streaks, milestones. */
export default function Toasts({ toasts, onDismiss }) {
  return (
    <div className="toasts" role="status" aria-live="polite">
      {toasts.map((toast) => (
        <Toast key={toast.id} toast={toast} onDismiss={onDismiss} />
      ))}
    </div>
  );
}

function Toast({ toast, onDismiss }) {
  useEffect(() => {
    const handle = setTimeout(() => onDismiss(toast.id), LIFETIME_MS);
    return () => clearTimeout(handle);
  }, [toast.id, onDismiss]);

  return (
    <button
      type="button"
      className={`toast toast--${toast.tone ?? 'xp'}`}
      onClick={() => onDismiss(toast.id)}
    >
      <strong className="toast__title">{toast.title}</strong>
      {toast.body ? <span className="toast__body">{toast.body}</span> : null}
    </button>
  );
}
